module.exports = __webpack_public_path__ + "static/media/20201216_211913_856_IMG_3275.4614899c.jpg";